import Vue from 'vue'

import 'normalize.css/normalize.css' // A modern alternative to CSS resets

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueI18n from 'vue-i18n'
import en from "element-ui/lib/locale/lang/en";
import vn from "element-ui/lib/locale/lang/vi";
import cn from "element-ui/lib/locale/lang/zh-CN";

import common from '@/utils/common'

Vue.use(common);
Vue.use(VueI18n)
import '@/styles/index.scss' // global css
import { localRead } from '@/utils/tools'
import App from './App'
import store from './store'
import router from './router'
import { getQueryString } from '@/utils/tools'

import '@/icons'
import {validUsername} from "@/utils/validate"; // icon
import './registerServiceWorker'


if (process.env.NODE_ENV === 'production') {
    const { mockXHR } = require('../mock')
    mockXHR()
}
let language = 'zh_CN'
if (localRead('language')) {
    language = localRead('language')
}
// ENV VARIABLE CHECK
console.log("domain=", process.env.VUE_APP_BASE_API);

const i18n = new VueI18n({

    locale: language, // 语言标识
    //this.$i18n.locale // 通过切换locale的值来实现语言切换
    messages: {
        'zh_CN': Object.assign(require("../src/assets/lang/lang-cn"), cn), // 中文语言包
        'en_US': Object.assign(require("../src/assets/lang/lang-en"), en), // 英文语言包
        'vi_VN': Object.assign(require("../src/assets/lang/lang-vn"), vn), // 越南语言包
    }
})

//定义权限控制指令
Vue.directive('auth', {
    bind: function(el, binding, vnode) {
        let menus;
        if (window.SITE_CONFIG['routerLabel']) {
            let label = window.SITE_CONFIG['routerLabel']
            menus = JSON.parse(localRead(label + '_buttons'));
        } else if (window.location.href.indexOf('label') != -1) {
            let label = getQueryString('label')
            menus = JSON.parse(localRead(label + '_buttons'));
        }
        const value = binding.value;
        let show = "hidden";
        if (value != null && value != '') {
            for (var i in menus) {
                if (menus[i].path == value) show = "visible";
            }
        } else show = "visible";
        el.style.visibility = show;
    }
});

Vue.use(ElementUI, {
    i18n: (key, value) => i18n.t(key, value)
});
//window.$t('my.temp') 封装国际化函数，方便在js中和this不生效时使用
window.$t = (key, value) =>i18n.t(key, value);
Vue.config.productionTip = false

new Vue({
    el: '#app',
    router,
    store,
    i18n,
    render: h => h(App)
})
